import {
  APIQueryOptions,
  APIQueryResult,
  useAPIQuery,
} from 'shared/api/APIQuery';
import { requestCarrierAPI } from 'shared/api/CarrierAPIClient';
import { FIVE_MINUTES } from 'shared/constants/NumberConstants';
import { createLocalStorageManager } from 'shared/helpers/Store';
import { PermissionDTO } from './PermissionDTO';
import { isLoadboardWebView } from 'shared/constants/AppTypeConstants';

export const userPermissionStore =
  createLocalStorageManager<PermissionDTO>('user_permissions');

export function useUserPermissions(
  options?: APIQueryOptions<PermissionDTO>,
): APIQueryResult<PermissionDTO> {
  return useAPIQuery(
    ['user', 'permissions'],
    () => requestCarrierAPI('GET /internal/web/users/permissions/'),
    {
      refetchOnWindowFocus: true,
      refetchOnMount: false,
      gcTime: FIVE_MINUTES,
      staleTime: FIVE_MINUTES,
      refetchInterval: FIVE_MINUTES,
      ...options,
      enabled: !isLoadboardWebView && (options?.enabled ?? true),
    },
  );
}
